<template lang="pug">
.environment-version(v-if="shouldRender")
  span {{environment + (latestCommit ? ' - ' : '')}}
  a.gitlab-link(v-if="latestCommit" href="https://git.briqbookings.com/briq/briq.app") {{ latestCommit.short_id }} {{ latestCommitDate }}
</template>

<script>
import { format } from 'date-fns'

export default {
  name: 'BriqEnvironment',
  props: {
    environment: String,
    gitlabToken: String,
  },
  data() {
    return {
      commits: null,
    }
  },
  computed: {
    latestCommit() {
      return this.commits && this.commits[0]
    },
    latestCommitDate() {
      if (!this.latestCommit) return null
      return format(new Date(this.latestCommit.created_at), 'yyyy-MM-dd')
    },
    shouldRender() {
      return this.environment && this.environment !== 'production'
    },
  },
  async mounted() {
    if (this.commits || !this.gitlabToken) return
    try {
      const response = await this.$apiClient.get(
        `https://git.briqbookings.com/api/v4/projects/5/repository/commits?private_token=${this.gitlabToken}`,
      )
      this.commits = response.data
    } catch (e) {
      console.warn('Could not connect to gitlab api')
      console.warn(e)
    }
  },
}
</script>

<style scoped lang="stylus">
.environment-version
  position absolute
  top 4px
  right 8px

  .gitlab-link
    text-decoration underline
</style>
